import type { Content, Image } from '@plone/types';

export interface QubicaViewProps {
  history?: object;
  location?: object;
  token?: string;
  content: QubicaContentProps;
}

export interface QubicaImageScalesProps {
  preview_image?: Image;
  alternative_preview_image?: Image;
  icon?: Image;
}

export interface QubicaContentProps extends Content {
  image_caption?: string;
  image_scales?: QubicaImageScalesProps;
  image_field?: string;
  jobtitle?: { title: string; token: string };
  reference?: string;
  address?: string;
  address_2?: string;
  city?: string;
  state?: string;
  state_2?: string;
  zipcode?: string;
  zipcode_2?: string;
  mobile?: string;
  mobile_2?: string;
  phone?: string;
  fax?: string;
  email?: string;
  www?: string;
  map_image?: object;
  base_title?: string;
  base_title_2?: string;
  latitude?: string;
  longitude?: string;
  base_type: string;
  contact_link?: string;
  localsite?: string;
}

export interface QubicaContactCardsStyleProps {
  bg: 'white' | 'gray';
}

export const representativeSections = [
  'district_sales_manager',
  'regional_sales_manager',
  'SVP_sales',
  'VP_sales',
  'product_specialist',
  'technical_support',
  'representative_office',
  'crm',
  'sales_assistant',
  'us_parts_and_suppliera_distributor',
] as const;

export interface RequestItem<
  T extends QubicaContentProps = QubicaContentProps,
> {
  batching: object;
  error: object | null;
  items: T[];
  loaded: boolean;
  loading: boolean;
  total: number;
}
